<button
  [ngClass]="btnClasses"
  [type]="htmlType"
  [disabled]="isDisabled"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-pressed]="ariaPressed()"
  (click)="onClick($event)"
>
  <!-- ── Icône gauche ──────────────────────────────────────────────── -->
  <span *ngIf="addIconLeft" class="btn__icon btn__icon--left">
    <span class="btn__icon-default">
      <ng-content select="[slot='icon-left']"></ng-content>
    </span>
    <span class="btn__icon-active">
      <ng-content select="[slot='icon-left-active']"></ng-content>
    </span>
  </span>

  <!-- ── Label ────────────────────────────────────────────────────── -->
  <span *ngIf="addLabel && label" class="btn__label">{{ label }}</span>

  <!-- ── Icône droite ─────────────────────────────────────────────── -->
  <span *ngIf="addIconRight" class="btn__icon btn__icon--right">
    <span class="btn__icon-default">
      <ng-content select="[slot='icon-right']"></ng-content>
    </span>
    <span class="btn__icon-active">
      <ng-content select="[slot='icon-right-active']"></ng-content>
    </span>
  </span>
</button>